export default "__VITE_ASSET__vnX7jj0N__"